export default __webpack_public_path__ + "static/media/background-image.9b46559f.png";